(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('loader',  loaderInject);

  /** @ngInject */
  function loaderInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/loader/loader.html',
      controller: LoaderController,
      controllerAs: 'vm',
      scope : {},
      replace: true,
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function LoaderController() {

    }
  }

})();
